import service from '@/utils/request'
// 查询供应商财务信息
export function supplierFinanceList(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierFinance/supplierFinanceList',
        data: param
    })
}
// 查询供应商财务信息 不分页
export function supplierFinanceListAll() {
    return service.request({
        method: 'POST',
        url: '/app/supplierFinance/list',
    })
}
// 新增供应商财务信息
export function addSupplierFinance(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierFinance/add',
        data: param
    })
}
// 修改供应商财务信息
export function editSupplierFinance(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierFinance/edit',
        data: param
    })
}

// 批量删除供应商财务信息
export function batchDelSupplierFinance(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierFinance/batchDel',
        data: param
    })
}



// 删除供应商财务信息
export function delSupplierFinance(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierFinance/del',
        data: param
    })
}
// 导出供应商财务信息
export function exportSupplierFinance(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierFinance/export',
        data: param
    })
}
